import { render, staticRenderFns } from "./resetUser.vue?vue&type=template&id=1458812e&scoped=true&"
import script from "./resetUser.vue?vue&type=script&lang=js&"
export * from "./resetUser.vue?vue&type=script&lang=js&"
import style0 from "./resetUser.vue?vue&type=style&index=0&id=1458812e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458812e",
  null
  
)

export default component.exports